export default __webpack_public_path__ + "static/media/nwzhcx.a8883042.png";